module.exports = __webpack_public_path__ + "static/media/image-banner-minha-conta.be251c77.jpg";